import Vue from 'vue';
import NProgress from 'vue-nprogress';
import VueGestios from 'gestios-sdk-vue';
import VueInfiniteScroll from 'vue-infinite-scroll';
import VuePlugins from '@/system/plugins';
import * as VueGoogleMaps from 'vue2-google-maps';

// Custom app settings
import settings from '@/application/config/settings';
import misc from '@/application/config/misc';
import menu from '@/application/config/menu';
import store from '@/system/store';
import router from './_router';
import utils from './_utils';

// Config
import './_styles';
import './_icons';
import './_firebase';
import './_service-worker';
import './_moment';
import './_validation';
import './_filters';
import './_components';

const nprogress = new NProgress({ parent: 'body' });
const config = { ...settings, ...misc };

Vue.use(VuePlugins, store);
Vue.use(VueInfiniteScroll);
Vue.use(VueGestios, {
	project: config.project,
	url: store.getters.settings.env === 'production' ? config.paths.api : config.paths.api_dev,
	events: {
		'message-success': (text) => Vue.prototype.$message.success(text),
		'message-error': (params) => {
			if (params.code !== 400) {
				Vue.prototype.$message.error(params.message);
			} else {
				Vue.prototype.$toast._400(params);
			}
		},
		'loader-start': () => nprogress.start(),
		'loader-done': () => nprogress.done()
	}
});

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyDNn6sg2TQBEkSygrLfDKh_LaLI9P58nUQ',
		libraries: 'places',
		region: 'ES',
		language: 'es'
	},
	installComponents: true
});

// VUE Hub & config
Vue.prototype.$hub = new Vue();
Vue.prototype.$helpers = utils();
Vue.prototype.$app = config;
Vue.prototype.$nprogress = nprogress;

Vue.config.productionTip = false;

export { router, settings, menu, store, nprogress };

export default Vue;
